// // Mock data for testing - remove this when you have real product data
// const mockProducts = [
// 	{
// 		title: "Drop-Down Tailgate Table - FORD Bronco 6G 2D",
// 		id: 1001,
// 		brand: ["Ford"],
// 		model: ["Bronco 6G 2D"],
// 		image: "//bisongear.myshopify.com/cdn/shop/files/2373.jpg?v=1744707837&width=400",
// 		documentUrl: "/files/TBL-BRN-6G2D_Installation_Guide.pdf",
// 		documentName: "TBL-BRN-6G2D",
// 	},
// 	{
// 		title: "Universal Roof Shelf - Multi-Vehicle",
// 		id: 1002,
// 		brand: ["Ford", "Chevrolet", "Toyota"],
// 		model: ["Bronco 6G 4D", "Tahoe 5th Gen", "4Runner 5th Gen"],
// 		image: "//bisongear.myshopify.com/cdn/shop/files/2373.jpg?v=1744707837&width=400",
// 		documentUrl: "/files/SH-UNIVERSAL_Installation_Guide.pdf",
// 		documentName: "SH-UNIVERSAL",
// 	},
// 	{
// 		title: "Side Step Rails - JEEP Wrangler JL",
// 		id: 1003,
// 		brand: ["Jeep"],
// 		model: ["Wrangler JL"],
// 		image: "//bisongear.myshopify.com/cdn/shop/files/2373.jpg?v=1744707837&width=400",
// 		documentUrl: "/files/SSR-WRG-JL_Installation_Guide.pdf",
// 		documentName: "SSR-WRG-JL",
// 	},
// 	{
// 		title: "Universal Front Bumper Guard - Mid-Size Trucks",
// 		id: 1004,
// 		brand: ["Toyota", "Nissan", "Honda"],
// 		model: ["Tacoma 3rd Gen", "Frontier 3rd Gen", "Ridgeline 2nd Gen"],
// 		image: "//bisongear.myshopify.com/cdn/shop/files/2373.jpg?v=1744707837&width=400",
// 		documentUrl: "/files/FBG-MIDSIZE_Installation_Guide.pdf",
// 		documentName: "FBG-MIDSIZE",
// 	},
// 	{
// 		title: "Heavy Duty Bed Rack System - Full-Size Trucks",
// 		id: 1005,
// 		brand: ["Ford", "Chevrolet", "RAM", "GMC"],
// 		model: ["F-150 13th Gen", "Silverado 1500", "1500 5th Gen", "Sierra 1500 4th Gen"],
// 		image: "//bisongear.myshopify.com/cdn/shop/files/2373.jpg?v=1744707837&width=400",
// 		documentUrl: "/files/BRS-FULLSIZE_Installation_Guide.pdf",
// 		documentName: "BRS-FULLSIZE",
// 	},
// 	{
// 		title: "Rock Sliders - JEEP Wrangler JK",
// 		id: 1006,
// 		brand: ["Jeep"],
// 		model: ["Wrangler JK"],
// 		documentUrl: "/files/RS-WRG-JK_Installation_Guide.pdf",
// 		documentName: "RS-WRG-JK",
// 	},
// 	{
// 		title: "Universal Skid Plate Set - SUVs",
// 		id: 1007,
// 		brand: ["Toyota", "Jeep", "Ford"],
// 		model: ["4Runner 5th Gen", "Grand Cherokee WK2", "Explorer 6th Gen"],
// 		documentUrl: "/files/SPS-SUV_Installation_Guide.pdf",
// 		documentName: "SPS-SUV",
// 	},
// 	{
// 		title: "Winch Mount - FORD Bronco 6G 2D",
// 		id: 1008,
// 		brand: ["Ford"],
// 		model: ["Bronco 6G 2D"],
// 		documentUrl: "/files/WM-BRN-6G2D_Installation_Guide.pdf",
// 		documentName: "WM-BRN-6G2D",
// 	},
// 	{
// 		title: "Universal Cargo Organizer - Large SUVs/Trucks",
// 		id: 1009,
// 		brand: ["Chevrolet", "GMC", "Ford", "Toyota"],
// 		model: ["Silverado 1500", "Sierra 1500 4th Gen", "F-150 13th Gen", "Tundra 3rd Gen"],
// 		documentUrl: "/files/CO-UNIVERSAL_Installation_Guide.pdf",
// 		documentName: "CO-UNIVERSAL",
// 	},
// 	{
// 		title: "Fender Flares - JEEP Gladiator JT",
// 		id: 1010,
// 		brand: ["Jeep"],
// 		model: ["Gladiator JT"],
// 		documentUrl: "/files/FF-GLD-JT_Installation_Guide.pdf",
// 		documentName: "FF-GLD-JT",
// 	},
// 	{
// 		title: "Universal Roof Rack Cross Bars - Compact SUVs",
// 		id: 1011,
// 		brand: ["Toyota", "Honda", "Mazda", "Subaru"],
// 		model: ["Highlander 4th Gen", "CR-V 5th Gen", "CX-5 2nd Gen", "Forester 5th Gen"],
// 		documentUrl: "/files/RRCB-COMPACT_Installation_Guide.pdf",
// 		documentName: "RRCB-COMPACT",
// 	},
// 	{
// 		title: "Universal Hitch Receiver - Class III",
// 		id: 1012,
// 		brand: ["Ford", "Chevrolet", "Toyota", "Honda"],
// 		model: ["Explorer 6th Gen", "Tahoe 5th Gen", "Highlander 4th Gen", "Pilot 3rd Gen"],
// 		documentUrl: "/files/HR-CLASS3_Installation_Guide.pdf",
// 		documentName: "HR-CLASS3",
// 	},
// 	{
// 		title: "Bull Bar - CHEVROLET Tahoe 5th Gen",
// 		id: 1013,
// 		brand: ["Chevrolet"],
// 		model: ["Tahoe 5th Gen"],
// 		documentUrl: "/files/BB-TAH-5G_Installation_Guide.pdf",
// 		documentName: "BB-TAH-5G",
// 	},
// 	{
// 		title: "Universal Running Boards - Full-Size Trucks",
// 		id: 1014,
// 		brand: ["Toyota", "Ford", "Chevrolet", "RAM"],
// 		model: ["Tundra 3rd Gen", "F-250 Super Duty", "Silverado 2500", "2500 4th Gen"],
// 		documentUrl: "/files/RB-FULLSIZE_Installation_Guide.pdf",
// 		documentName: "RB-FULLSIZE",
// 	},
// 	{
// 		title: "Spare Tire Carrier - JEEP Wrangler JL",
// 		id: 1015,
// 		brand: ["Jeep"],
// 		model: ["Wrangler JL"],
// 		documentUrl: "/files/STC-WRG-JL_Installation_Guide.pdf",
// 		documentName: "STC-WRG-JL",
// 	},
// 	{
// 		title: "Universal Tonneau Cover - Mid-Size Trucks",
// 		id: 1016,
// 		brand: ["Ford", "Toyota", "Nissan", "Honda"],
// 		model: ["Ranger 4th Gen", "Tacoma 3rd Gen", "Frontier 3rd Gen", "Ridgeline 2nd Gen"],
// 		documentUrl: "/files/TC-MIDSIZE_Installation_Guide.pdf",
// 		documentName: "TC-MIDSIZE",
// 	},
// 	{
// 		title: "Light Bar Mount - CHEVROLET Colorado 2nd Gen",
// 		id: 1017,
// 		brand: ["Chevrolet"],
// 		model: ["Colorado 2nd Gen"],
// 		documentUrl: "/files/LBM-COL-2G_Installation_Guide.pdf",
// 		documentName: "LBM-COL-2G",
// 	},
// 	{
// 		title: "Universal Mud Flaps - Compact Cars",
// 		id: 1018,
// 		brand: ["Toyota", "Honda", "Nissan", "Mazda"],
// 		model: ["RAV4 5th Gen", "Civic 11th Gen", "Altima 6th Gen", "Mazda3 4th Gen"],
// 		documentUrl: "/files/MF-COMPACT_Installation_Guide.pdf",
// 		documentName: "MF-COMPACT",
// 	},
// 	{
// 		title: "Brush Guard - JEEP Grand Cherokee WK2",
// 		id: 1019,
// 		brand: ["Jeep"],
// 		model: ["Grand Cherokee WK2"],
// 		documentUrl: "/files/BG-GC-WK2_Installation_Guide.pdf",
// 		documentName: "BG-GC-WK2",
// 	},
// 	{
// 		title: "Universal Bed Liner - Heavy Duty Trucks",
// 		id: 1020,
// 		brand: ["Ford", "Chevrolet", "RAM", "GMC"],
// 		model: ["F-250 Super Duty", "Silverado 2500", "2500 4th Gen", "Sierra 2500"],
// 		documentUrl: "/files/BL-HEAVYDUTY_Installation_Guide.pdf",
// 		documentName: "BL-HEAVYDUTY",
// 	},
// 	{
// 		title: "Universal Roof Basket - Large SUVs",
// 		id: 1021,
// 		brand: ["Chevrolet", "GMC", "Ford", "Toyota"],
// 		model: ["Suburban 12th Gen", "Yukon 5th Gen", "Expedition 4th Gen", "Sequoia 2nd Gen"],
// 		documentUrl: "/files/RB-LARGESUV_Installation_Guide.pdf",
// 		documentName: "RB-LARGESUV",
// 	},
// 	{
// 		title: "Universal Door Sill Guards - Sedans",
// 		id: 1022,
// 		brand: ["Toyota", "Honda", "Nissan", "Mazda"],
// 		model: ["Camry 8th Gen", "Accord 10th Gen", "Altima 6th Gen", "Mazda6 3rd Gen"],
// 		documentUrl: "/files/DSG-SEDAN_Installation_Guide.pdf",
// 		documentName: "DSG-SEDAN",
// 	},
// 	{
// 		title: "Grille Guard - JEEP Cherokee KL",
// 		id: 1023,
// 		brand: ["Jeep"],
// 		model: ["Cherokee KL"],
// 		documentUrl: "/files/GG-CHR-KL_Installation_Guide.pdf",
// 		documentName: "GG-CHR-KL",
// 	},
// 	{
// 		title: "Universal Tailgate Assist - Compact Trucks",
// 		id: 1024,
// 		brand: ["Ford", "Honda", "Nissan"],
// 		model: ["Maverick 1st Gen", "Ridgeline 2nd Gen", "Frontier 3rd Gen"],
// 		documentUrl: "/files/TA-COMPACT_Installation_Guide.pdf",
// 		documentName: "TA-COMPACT",
// 	},
// 	{
// 		title: "Universal Side Mirror Guards - Crossovers",
// 		id: 1025,
// 		brand: ["Chevrolet", "Toyota", "Honda", "Subaru"],
// 		model: ["Equinox 3rd Gen", "RAV4 5th Gen", "CR-V 5th Gen", "Crosstrek 2nd Gen"],
// 		documentUrl: "/files/SMG-CROSSOVER_Installation_Guide.pdf",
// 		documentName: "SMG-CROSSOVER",
// 	},
// 	{
// 		title: "Universal Cargo Net - Minivans",
// 		id: 1026,
// 		brand: ["Toyota", "Honda", "Chrysler"],
// 		model: ["Sienna 4th Gen", "Odyssey 5th Gen", "Pacifica 1st Gen"],
// 		documentUrl: "/files/CN-MINIVAN_Installation_Guide.pdf",
// 		documentName: "CN-MINIVAN",
// 	},
// 	{
// 		title: "Hood Deflector - JEEP Compass 2nd Gen",
// 		id: 1027,
// 		brand: ["Jeep"],
// 		model: ["Compass 2nd Gen"],
// 		documentUrl: "/files/HD-COM-2G_Installation_Guide.pdf",
// 		documentName: "HD-COM-2G",
// 	},
// 	{
// 		title: "Universal Bed Extender - Super Duty Trucks",
// 		id: 1028,
// 		brand: ["Ford", "Chevrolet", "RAM"],
// 		model: ["F-350 Super Duty", "Silverado 3500", "3500 4th Gen"],
// 		documentUrl: "/files/BE-SUPERDUTY_Installation_Guide.pdf",
// 		documentName: "BE-SUPERDUTY",
// 	},
// 	{
// 		title: "Universal Window Visors - Mid-Size Sedans",
// 		id: 1029,
// 		brand: ["Chevrolet", "Toyota", "Honda", "Nissan"],
// 		model: ["Malibu 9th Gen", "Camry 8th Gen", "Accord 10th Gen", "Altima 6th Gen"],
// 		documentUrl: "/files/WV-MIDSEDAN_Installation_Guide.pdf",
// 		documentName: "WV-MIDSEDAN",
// 	},
// 	{
// 		title: "Universal Splash Guards - Hybrid Vehicles",
// 		id: 1030,
// 		brand: ["Toyota", "Honda", "Ford"],
// 		model: ["Prius 4th Gen", "Insight 3rd Gen", "Escape Hybrid 4th Gen"],
// 		documentUrl: "/files/SG-HYBRID_Installation_Guide.pdf",
// 		documentName: "SG-HYBRID",
// 	},
// ];

if (!customElements.get("instructions-search")) {
	class InstructionsSearch extends HTMLElement {
		constructor() {
			super();
			this.products = [];
			this.filteredProducts = [];
			this.displayedProducts = [];
			this.selectedBrand = "";
			this.selectedModel = "";
			this.selectedInstruction = "";
			this.itemsPerPage = 18;
			this.currentPage = 1;

			window.initLazyScript ? window.initLazyScript(this, this.init.bind(this)) : this.init();
		}

		init() {
			this.setupEventListeners();

			// Use mock data if no real products are available
			if (
				window.instructionsSearch &&
				window.instructionsSearch.allProducts &&
				window.instructionsSearch.allProducts.length > 0
			) {
				this.setProducts(window.instructionsSearch.allProducts);
			}
			// this.setProducts(mockProducts);
		}

		setProducts(products) {
			this.products = products.filter((product) => product.documentUrl);
			this.filteredProducts = [...this.products];
			this.currentPage = 1;
			this.updateDropdowns();
			this.renderResults();
		}

		setupEventListeners() {
			const brandSelect = this.querySelector("#brand-select");
			const modelSelect = this.querySelector("#model-select");
			const instructionSelect = this.querySelector("#instruction-select");

			brandSelect.addEventListener("change", (e) => {
				this.selectedBrand = e.target.value;
				this.selectedModel = "";
				this.selectedInstruction = "";
				this.currentPage = 1;
				this.filterProducts();
				this.updateDropdowns();
			});

			modelSelect.addEventListener("change", (e) => {
				this.selectedModel = e.target.value;
				this.selectedInstruction = "";
				this.currentPage = 1;
				this.filterProducts();
				this.updateDropdowns();
			});

			instructionSelect.addEventListener("change", (e) => {
				this.selectedInstruction = e.target.value;
				this.currentPage = 1;
				this.filterProducts();
			});
		}

		filterProducts() {
			this.filteredProducts = this.products.filter((product) => {
				const brandMatch =
					!this.selectedBrand || (product.brand && product.brand.some((brand) => brand === this.selectedBrand));

				const modelMatch =
					!this.selectedModel || (product.model && product.model.some((model) => model === this.selectedModel));

				const instructionMatch =
					!this.selectedInstruction ||
					(product.documentName && product.documentName.includes(this.selectedInstruction));

				return brandMatch && modelMatch && instructionMatch;
			});

			this.currentPage = 1;
			this.renderResults();
		}

		updateDropdowns() {
			this.updateBrandDropdown();
			this.updateModelDropdown();
			this.updateInstructionDropdown();
		}

		updateBrandDropdown() {
			const brandSelect = this.querySelector("#brand-select");
			const brands = new Set();

			this.products.forEach((product) => {
				if (product.brand) {
					product.brand.forEach((brand) => brands.add(brand));
				}
			});

			const currentValue = brandSelect.value;
			const defaultText = brandSelect.querySelector('option[value=""]')?.textContent || "All Brands";
			brandSelect.innerHTML = `<option value="">${defaultText}</option>`;

			Array.from(brands)
				.sort()
				.forEach((brand) => {
					const option = document.createElement("option");
					option.value = brand;
					option.textContent = brand;
					if (brand === currentValue) option.selected = true;
					brandSelect.appendChild(option);
				});
		}

		updateModelDropdown() {
			const modelSelect = this.querySelector("#model-select");
			const models = new Set();

			const relevantProducts = this.selectedBrand
				? this.products.filter((product) => product.brand && product.brand.includes(this.selectedBrand))
				: this.products;

			relevantProducts.forEach((product) => {
				if (product.model) {
					product.model.forEach((model) => models.add(model));
				}
			});

			const currentValue = modelSelect.value;
			const defaultText = modelSelect.querySelector('option[value=""]')?.textContent || "All Models";
			modelSelect.innerHTML = `<option value="">${defaultText}</option>`;

			Array.from(models)
				.sort()
				.forEach((model) => {
					const option = document.createElement("option");
					option.value = model;
					option.textContent = model;
					if (model === currentValue) option.selected = true;
					modelSelect.appendChild(option);
				});

			// Reset model selection if it's no longer valid
			if (this.selectedModel && !models.has(this.selectedModel)) {
				this.selectedModel = "";
				modelSelect.value = "";
			}
		}

		updateInstructionDropdown() {
			const instructionSelect = this.querySelector("#instruction-select");
			const instructions = new Set();

			let relevantProducts = this.products;

			if (this.selectedBrand) {
				relevantProducts = relevantProducts.filter(
					(product) => product.brand && product.brand.includes(this.selectedBrand)
				);
			}

			if (this.selectedModel) {
				relevantProducts = relevantProducts.filter(
					(product) => product.model && product.model.includes(this.selectedModel)
				);
			}

			relevantProducts.forEach((product) => {
				if (product.documentName) {
					instructions.add(product.documentName);
				}
			});

			const currentValue = instructionSelect.value;
			const defaultText = instructionSelect.querySelector('option[value=""]')?.textContent || "All Instructions";
			instructionSelect.innerHTML = `<option value="">${defaultText}</option>`;

			Array.from(instructions)
				.sort()
				.forEach((instruction) => {
					const option = document.createElement("option");
					option.value = instruction;
					option.textContent = instruction;
					if (instruction === currentValue) option.selected = true;
					instructionSelect.appendChild(option);
				});

			// Reset instruction selection if it's no longer valid
			if (this.selectedInstruction && !instructions.has(this.selectedInstruction)) {
				this.selectedInstruction = "";
				instructionSelect.value = "";
			}
		}

		renderResults() {
			const resultsContainer = this.querySelector("#search-results");

			if (this.filteredProducts.length === 0) {
				resultsContainer.innerHTML =
					'<div class="instructions-search__no-results">No instructions found matching your criteria.</div>';
				return;
			}

			this.displayedProducts = this.getDisplayedProducts();

			// Clear the container
			resultsContainer.innerHTML = "";

			// Create product cards using template
			this.displayedProducts.forEach((product) => {
				const productCard = this.createProductCard(product);
				resultsContainer.appendChild(productCard);
			});

			// Add load more button if needed
			if (this.hasMoreProducts()) {
				const loadMoreButton = this.createLoadMoreButton();
				resultsContainer.appendChild(loadMoreButton);
			}
		}

		createProductCard(product) {
			const template = this.querySelector("#product-card-template");
			const clone = template.content.cloneNode(true);

			// Set image
			const imageElement = clone.querySelector('[data-field="image"]');
			const imageValue = clone.querySelector('[data-value="image"]');
			if (product.image) {
				imageValue.src = product.image;
				imageValue.alt = product.title;
				imageElement.style.display = "block";
			} else {
				imageElement.style.display = "none";
			}

			// Set title
			const titleElement = clone.querySelector('[data-field="title"]');
			titleElement.textContent = product.title;

			// Set brand
			const brandElement = clone.querySelector('[data-field="brand"]');
			const brandValue = clone.querySelector('[data-value="brand"]');
			if (product.brand && product.brand.length > 0) {
				brandValue.textContent = product.brand.join(", ");
				brandElement.style.display = "block";
			} else {
				brandElement.style.display = "none";
			}

			// Set model
			const modelElement = clone.querySelector('[data-field="model"]');
			const modelValue = clone.querySelector('[data-value="model"]');
			if (product.model && product.model.length > 0) {
				modelValue.textContent = product.model.join(", ");
				modelElement.style.display = "block";
			} else {
				modelElement.style.display = "none";
			}

			// Set document
			const documentElement = clone.querySelector('[data-field="document"]');
			const documentValue = clone.querySelector('[data-value="document"]');
			if (product.documentName) {
				documentValue.textContent = product.documentName;
				documentElement.style.display = "block";
			} else {
				documentElement.style.display = "none";
			}

			// Set download link with instruction name
			const downloadLink = clone.querySelector('[data-field="download"]');
			downloadLink.href = product.documentUrl;

			// Update button text to include instruction name
			if (product.documentName) {
				// Get the translated "Download" text and append instruction name
				const translatedDownload = downloadLink.childNodes[0].textContent.trim();
				downloadLink.childNodes[0].textContent = `${translatedDownload} ${product.documentName} `;
			}

			return clone;
		}

		createLoadMoreButton() {
			const template = this.querySelector("#load-more-template");
			const clone = template.content.cloneNode(true);

			// Set remaining count
			const remainingElement = clone.querySelector('[data-field="remaining"]');
			const remainingCount = this.filteredProducts.length - this.displayedProducts.length;
			remainingElement.textContent = remainingCount;

			// Add event listener
			const button = clone.querySelector('[data-field="button"]');
			button.addEventListener("click", () => this.loadMore());

			return clone;
		}

		loadMore() {
			this.currentPage++;
			this.renderResults();
		}

		getDisplayedProducts() {
			const startIndex = 0;
			const endIndex = this.currentPage * this.itemsPerPage;
			return this.filteredProducts.slice(startIndex, endIndex);
		}

		hasMoreProducts() {
			return this.filteredProducts.length > this.currentPage * this.itemsPerPage;
		}
	}

	customElements.define("instructions-search", InstructionsSearch);
}
